import {call, put} from 'redux-saga/effects';
import DictionariesActions from '../redux/DictionariesRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getDictionaries(api, action) {
  const {name, query} = action;
  const response = yield call(api.getDictionaries, name, query);
  if (response.ok) {
    yield put(DictionariesActions.dictionariesSuccess(name, response.data));
  } else {
    yield put(DictionariesActions.dictionariesFailure(name, response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
